module.exports = __webpack_public_path__ + "static/media/watch1.045af90d.jpg";